module.exports = __webpack_public_path__ + "assets/img/16@3x.3ada562f.png";